// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!../../../../templatemanager/customTemplate.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .kore-action-sheet .listViewTmplContentBox .close-button {
  cursor: pointer;
  margin: 0;
  padding-top: 8px;
  position: absolute;
  right: 10px;
  top: 10px;
  color: var(--sdk-chat-window-list-template-close-btn-color);
  background: none;
  opacity: 1;
  outline: none;
  font-size: 30px;
  float: right;
  line-height: inherit;
  border: none;
}

.kore-chat-window .kore-chat-body .listViewTmplContent .listViewTmplContentBox {
  float: left;
  color: var(--sdk-chat-window-list-view-color);
  border-radius: 12px;
  padding: 0;
  font-size: 14px;
  -webkit-animation: message-left ease-in-out 2s forwards;
  -moz-animation: message-left ease-in-out 2s forwards;
  animation: message-left ease-in-out 2s forwards;
  margin: 0;
  width: 100%;
}

.kore-chat-window .kore-chat-body .listViewTmplContent .listViewLeftContent {
  vertical-align: middle;
  display: table-cell;
  padding: 0 10px;
  width: 100%;
}

.kore-chat-window .kore-chat-body .listViewTmplContent .listViewRightContent {
  cursor: pointer;
  display: table-cell;
  width: 60px;
  vertical-align: middle;
  padding-left: 10px;
}

.kore-chat-window .kore-chat-body .listViewRightContent img {
  height: 36px;
  width: 36px;
  border-radius: 50%;
}

.kore-chat-window .kore-chat-body .listViewTmplContent .listViewTmplContentChild {
  border-top: 1px solid var(--sdk-chat-window-checkbox-border);
  margin-bottom: 10px;
  width: 100%;
  border-radius: 10px;
  box-shadow: var(--sdk-chat-widow-primary-box-shadow);
  background-color: var(--sdk-chat-widow-default-white);
  height: 56px;
  display: table;
  vertical-align: middle;
  cursor: pointer;
}

.kore-chat-window .kore-chat-body .listViewTmplContent .listViewItemSubtitle {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 102px;
  height: 18px; */
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.27px;
  color: var(--sdk-chat-window-list-template-sub-title-color);
}

.kore-chat-window .kore-chat-body .listViewTmplContent .listViewItemValue {
  display: inline-block;
  /* margin-left: 15px;  */
  color: var(--sdk-chat-window-list-template-value-color);
  /* width: 66px;
  height: 22px; */
  font-size: 14px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  text-align: right;
  color: var(--sdk-chat-window-list-view-value-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 33%;
}

.kore-chat-window .kore-chat-body .listViewTmplContent .listItemPath {
  font-size: 12px;
  color: var(--sdk-chat-window-viewmore-btn-color);
  cursor: pointer;
}

.kore-chat-window .kore-chat-body .listViewTmplContent .buyBtn {
  background: var(--sdk-chat-window-bg-color);
  border: 0;
  color: var(--sdk-chat-window-viewmore-btn-color) !important;
  cursor: pointer;
  float: right;
  font-weight: bold;
  letter-spacing: -0.3px;
  font-size: 12px;
  text-align: right;
}

.kore-chat-window .kore-chat-body .listViewTmplContentBox li:first-child {
  margin-top: 0 !important;
  border-top: 0;
}

.kore-chat-window .kore-chat-body .listViewTmplContent .listViewTmplContentHeading {
  padding: 10px;
  background: var(--sdk-chat-window-list-template-heading-background-color);
  margin-bottom: 10px;
  border-radius: 12px 12px 0 0;
  font-size: 15px;
  width: 100%;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.11px;
  color: var(--sdk-chat-widow-primary-font-color);
}

.kore-chat-window .kore-chat-body .listViewTmplContent .listViewLeftContent .titleDesc {
  display: inline-block;
  width: 65%;
}

.kore-chat-window .kore-chat-body .list-template-sheet .listViewItemTitle, .kore-chat-window .kore-chat-body .listItems .listViewItemTitle {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.54;
  letter-spacing: -0.1px;
  color: var(--sdk-chat-window-list-template-title-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kore-chat-window .kore-chat-body .listViewTmplContent .seeMoreList {
  text-align: center;
  border-top: 1px solid var(--sdk-chat-window-checkbox-border);
  padding: 10px;
  margin: 0;
}

.kore-chat-window .kore-chat-body .listViewTmplContent .seeMoreList {
  border: 0;
  background: none;
  color: var(--sdk-chat-widow-primary-blue-color) !important;
  cursor: pointer;
  float: right;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 5px;
  letter-spacing: normal;
  display: inline-block;
  border-bottom: 1px solid var(--sdk-chat-widow-primary-blue-color);
  padding: 10px 0;
  text-align: center;
}

.kore-chat-window .kore-action-sheet.hide {
  display: none !important;
}

.kore-chat-window .kore-action-sheet .list-template-sheet {
  position: absolute;
  width: 100%;
  z-index: 9;
  bottom: 0;
  /* box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.22); */
  background: var(--sdk-chat-window-bg-color);
  height: 400px;
  cursor: default;
  overflow-y: auto;
}

.kore-chat-window .kore-action-sheet .list-template-sheet .sheetHeader {
  height: 50px;
  width: 100%;
}

.kore-chat-window .kore-action-sheet .list-template-sheet .sheetHeader .choose {
  margin-left: 11px;
  width: 135px;
  height: 20px;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.3;
  letter-spacing: normal;
  color: var(--sdk-chat-window-list-template-choose-color);
}

.kore-chat-window .kore-action-sheet .list-template-sheet .listViewLeftContent .titleDesc {
  display: inline-block;
  width: 65%;
}

.kore-chat-window .kore-action-sheet .list-template-sheet .sheetHeader .close-button {
  margin: 0;
  padding-top: 8px;
  cursor: pointer;
}

.kore-chat-window .kore-action-sheet .list-template-sheet .sheetHeader .close-button {
  cursor: pointer;
  color: var(--sdk-chat-window-list-template-close-btn-color);
  background: none;
  border: none;
  opacity: 1;
  outline: none;
  font-size: 30px;
  float: right;
  line-height: inherit;
  margin-right: 20px;
  margin-top: 10px;
  padding: 0 6px;
}

.kore-chat-window .kore-action-sheet .list-template-sheet .listViewTmplContentChild {
  border-top: 1px solid var(--sdk-chat-window-checkbox-border);
  margin-bottom: 10px;
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);
  background-color: var(--sdk-chat-widow-default-white);
  height: 56px;
  cursor: pointer;
  display: table;
}

.kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayMonth {
  width: 40%;
  margin: 0 auto;
}

.kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayMonth .tabs {
  color: var(--sdk-chat-window-list-template-sub-title-color);
  cursor: pointer;
  font-size: 14px;
}

.kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayMonth .tabs:last-child {
  float: right;
}

.kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayMonth .tabs.active {
  font-size: 14px;
  font-weight: bold;
  color: var(--sdk-chat-widow-primary-blue-color);
}

.kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayMonth .btnBG {
  height: 26px;
  border-radius: 6px;
  display: inline-block;
  padding: 5px 10px;
  text-align: center;
}

.kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayMonth .tabs.active .btnBG {
  background-color: var(--sdk-chat-window-viewmore-btn-color);
  color: var(--sdk-chat-widow-default-white);
}

.kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .listViewRightContent img {
  height: 36px;
  width: 36px;
  border-radius: 50%;
}

.kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayListValues {
  width: 100%;
  padding: 0 10px;
}

.kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayListValues .displayListValues {
  padding: 0;
}

.kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayListValues .listViewRightContent {
  cursor: pointer;
  display: table-cell;
  width: 60px;
  vertical-align: middle;
  padding-left: 10px;
}

.kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayListValues .listViewLeftContent {
  width: 100%;
  padding: 0 10px;
  vertical-align: middle;
  display: table-cell;
}

.kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayListValues .listViewLeftContent .listViewItemTitle {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.54;
  letter-spacing: -0.1px;
  color: var(--sdk-chat-window-list-template-title-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayListValues .listViewLeftContent .listViewItemSubtitle {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 102px;
  height: 18px; */
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.27px;
  color: var(--sdk-chat-window-list-template-sub-title-color);
}

.kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayListValues .listViewLeftContent .listViewItemValue {
  display: inline-block;
  /* margin-left: 15px;  */
  color: var(--sdk-chat-window-list-template-value-color);
  /* width: 66px;
  height: 22px; */
  font-size: 14px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  text-align: right;
  color: var(--sdk-chat-window-list-view-value-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 33%;
}`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/listViewTemplate/listViewTemplate.scss"],"names":[],"mappings":"AACA;EACI,eAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,2DAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;AACJ;;AACA;EACC,WAAA;EACA,6CAAA;EACA,mBAAA;EACG,UAAA;EACH,eAAA;EACA,uDAAA;EACG,oDAAA;EACA,+CAAA;EACH,SAAA;EACA,WAAA;AAED;;AAAA;EACI,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAGJ;;AADA;EACI,eAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AAIJ;;AADA;EACC,YAAA;EACA,WAAA;EACG,kBAAA;AAIJ;;AADA;EACC,4DAAA;EACA,mBAAA;EACG,WAAA;EACA,mBAAA;EACA,oDAAA;EACA,qDAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;AAIJ;;AAFA;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA;iBAAA;EAEA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,2DAAA;AAKJ;;AAFA;EAEI,qBAAA;EACC,wBAAA;EACD,uDAAA;EACA;iBAAA;EAEA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mDAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAIJ;;AADA;EACC,eAAA;EACA,gDAAA;EACG,eAAA;AAIJ;;AAFA;EACC,2CAAA;EACG,SAAA;EACA,2DAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AAKJ;;AAHA;EACC,wBAAA;EACA,aAAA;AAMD;;AAJA;EACC,aAAA;EACG,yEAAA;EACA,mBAAA;EACA,4BAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,+CAAA;AAOJ;;AALA;EACI,qBAAA;EACA,UAAA;AAQJ;;AALA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,uDAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAQJ;;AANA;EACC,kBAAA;EACG,4DAAA;EACA,aAAA;EACA,SAAA;AASJ;;AAPA;EACC,SAAA;EACG,gBAAA;EACA,0DAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iEAAA;EACA,eAAA;EACA,kBAAA;AAUJ;;AARA;EACI,wBAAA;AAWJ;;AATA;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,gDAAA;EACA,2CAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AAYJ;;AAVA;EACI,YAAA;EACA,WAAA;AAaJ;;AAXA;EACI,iBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,wDAAA;AAcJ;;AAXA;EACI,qBAAA;EACA,UAAA;AAcJ;;AAZA;EACI,SAAA;EACA,gBAAA;EACA,eAAA;AAeJ;;AAbA;EACI,eAAA;EACA,2DAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAgBJ;;AAbA;EACI,4DAAA;EACH,mBAAA;EACG,WAAA;EACA,mBAAA;EACA,iDAAA;EACA,qDAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAgBJ;;AAdI;EACE,UAAA;EACA,cAAA;AAiBN;;AAfI;EACI,2DAAA;EACA,eAAA;EACA,eAAA;AAkBR;;AAhBI;EACI,YAAA;AAmBR;;AAjBI;EAEQ,eAAA;EACA,iBAAA;EACA,+CAAA;AAmBZ;;AAhBI;EACI,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;AAmBR;;AAhBI;EACI,2DAAA;EACA,0CAAA;AAmBR;;AAhBI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AAmBR;;AAjBI;EACI,WAAA;EACA,eAAA;AAoBR;;AAlBI;EACI,UAAA;AAqBR;;AAnBI;EACI,eAAA;EACJ,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AAsBJ;;AApBI;EACI,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;AAuBR;;AArBI;EACI,eAAA;EACJ,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,uDAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAwBJ;;AAtBC;EACG,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA;iBAAA;EAEA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,2DAAA;AAyBJ;;AAtBC;EACG,qBAAA;EACC,wBAAA;EACD,uDAAA;EACA;iBAAA;EAEA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mDAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAyBJ","sourcesContent":["@import '../../../../templatemanager/customTemplate.css';\n.kore-chat-window .kore-action-sheet .listViewTmplContentBox .close-button{\n    cursor: pointer;\n    margin: 0;\n    padding-top: 8px;\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    color:var(--sdk-chat-window-list-template-close-btn-color);\n    background:none;\n    opacity:1;\n    outline:none;\n    font-size:30px;\n    float:right;\n    line-height:inherit;\n    border:none;\n}\n.kore-chat-window .kore-chat-body .listViewTmplContent .listViewTmplContentBox{\n\tfloat:left;\n\tcolor:var(--sdk-chat-window-list-view-color);\n\tborder-radius: 12px;\n    padding: 0;\n\tfont-size: 14px;\n\t-webkit-animation: message-left ease-in-out 2s forwards;\n    -moz-animation: message-left ease-in-out 2s forwards;\n    animation: message-left ease-in-out 2s forwards;\n\tmargin: 0;\n\twidth:100%;\n}\n.kore-chat-window .kore-chat-body .listViewTmplContent .listViewLeftContent{\n    vertical-align: middle;\n    display: table-cell;\n    padding: 0 10px;\n    width: 100%;\n}\n.kore-chat-window .kore-chat-body .listViewTmplContent .listViewRightContent{\n    cursor: pointer;\n    display: table-cell;\n    width: 60px;\n    vertical-align: middle;\n    padding-left: 10px;\n\n}\n.kore-chat-window .kore-chat-body .listViewRightContent img{\n\theight: 36px;\n\twidth: 36px;\n    border-radius: 50%;\n    \n}\n.kore-chat-window .kore-chat-body .listViewTmplContent .listViewTmplContentChild{\n\tborder-top: 1px solid var(--sdk-chat-window-checkbox-border);\n\tmargin-bottom:10px;\n    width: 100%;\n    border-radius: 10px;\n    box-shadow: var(--sdk-chat-widow-primary-box-shadow);\n    background-color: var(--sdk-chat-widow-default-white);\n    height: 56px;\n    display: table;\n    vertical-align: middle;\t\n    cursor: pointer;\n}\n.kore-chat-window .kore-chat-body .listViewTmplContent .listViewItemSubtitle{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    /* width: 102px;\n    height: 18px; */\n    font-size: 13px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: 0.27px;\n    color: var(--sdk-chat-window-list-template-sub-title-color);\n      \n}\n.kore-chat-window .kore-chat-body .listViewTmplContent .listViewItemValue{\n    \n    display: inline-block;\n     /* margin-left: 15px;  */\n    color: var(--sdk-chat-window-list-template-value-color);\n    /* width: 66px;\n    height: 22px; */\n    font-size: 14px;\n    font-weight: 900;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: 0.4px;\n    text-align: right;\n    color:  var(--sdk-chat-window-list-view-value-color);\n    overflow: hidden;\n    text-overflow: ellipsis; \n    white-space: nowrap;\n    width:33%;\n      \n}\n.kore-chat-window .kore-chat-body .listViewTmplContent .listItemPath{\n\tfont-size:12px;\n\tcolor: var(--sdk-chat-window-viewmore-btn-color);\n    cursor: pointer;\n}\n.kore-chat-window .kore-chat-body .listViewTmplContent .buyBtn{\n\tbackground: var(--sdk-chat-window-bg-color);\n    border: 0;\n    color: var(--sdk-chat-window-viewmore-btn-color)!important;\n    cursor: pointer;\n    float: right;\n    font-weight: bold;\n    letter-spacing: -0.3px;\n    font-size: 12px;\n    text-align: right;\n}\n.kore-chat-window .kore-chat-body .listViewTmplContentBox li:first-child{\n\tmargin-top:0!important;\n\tborder-top:0;\n}\n.kore-chat-window .kore-chat-body .listViewTmplContent .listViewTmplContentHeading{\n\tpadding:10px;\n    background: var(--sdk-chat-window-list-template-heading-background-color);\n    margin-bottom: 10px;\n    border-radius: 12px 12px 0 0;\n    font-size: 15px;\n    width: 100%;\n    font-size: 15px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.33;\n    letter-spacing: -0.11px;\n    color: var(--sdk-chat-widow-primary-font-color);\n}\n.kore-chat-window .kore-chat-body .listViewTmplContent .listViewLeftContent .titleDesc{\n    display: inline-block;\n    width:65%;\n}\n\n.kore-chat-window .kore-chat-body .list-template-sheet .listViewItemTitle,.kore-chat-window .kore-chat-body .listItems .listViewItemTitle {\t\n    font-size: 13px;\t\n    font-weight: 600;\t\n    line-height: 1.54;\t\n    letter-spacing: -0.1px;\t\n    color: var(--sdk-chat-window-list-template-title-color);\t\n    overflow: hidden;\t\n    text-overflow: ellipsis;\t\n    white-space: nowrap;\t\n}\n.kore-chat-window .kore-chat-body .listViewTmplContent .seeMoreList{\n\ttext-align: center;\n    border-top: 1px solid var(--sdk-chat-window-checkbox-border);\n    padding: 10px;\n    margin: 0;\n}\n.kore-chat-window .kore-chat-body .listViewTmplContent .seeMoreList{\n\tborder: 0;\n    background: none;\n    color: var(--sdk-chat-widow-primary-blue-color)!important;\n    cursor: pointer;\n    float: right;\n    font-size: 14px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 5px;\n    letter-spacing: normal;\n    display: inline-block;\t\n    border-bottom: 1px solid var(--sdk-chat-widow-primary-blue-color);\t\n    padding: 10px 0;\t\n    text-align: center;\n}\n.kore-chat-window .kore-action-sheet.hide{\n    display:none!important;\n}\n.kore-chat-window .kore-action-sheet .list-template-sheet{\n    position: absolute;\n    width: 100%;\n    z-index: 9;\n    bottom: 0;\n    /* box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.22); */\n    background: var(--sdk-chat-window-bg-color);\n    height: 400px;\n    cursor: default;\n    overflow-y: auto;\n}\n.kore-chat-window .kore-action-sheet .list-template-sheet .sheetHeader{\n    height:50px;\n    width:100%;\n}\n.kore-chat-window .kore-action-sheet .list-template-sheet .sheetHeader .choose{\n    margin-left:11px;\n    width: 135px;\n    height: 20px;\n    font-size: 18px;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 2.3;\n    letter-spacing: normal;\n    color: var(--sdk-chat-window-list-template-choose-color);\n      \n}\n.kore-chat-window .kore-action-sheet .list-template-sheet .listViewLeftContent .titleDesc{\n    display: inline-block;\n    width:65%;\n}\n.kore-chat-window .kore-action-sheet .list-template-sheet .sheetHeader .close-button{\n    margin: 0;\n    padding-top: 8px;\n    cursor: pointer;\n}\n.kore-chat-window .kore-action-sheet  .list-template-sheet .sheetHeader .close-button{\n    cursor: pointer;\n    color: var(--sdk-chat-window-list-template-close-btn-color);\n    background: none;\n    border: none;\n    opacity: 1;\n    outline: none;\n    font-size: 30px;\n    float:right;\n    line-height: inherit;\n    margin-right: 20px;\n    margin-top: 10px;\n    padding: 0 6px;\n}\n\n.kore-chat-window .kore-action-sheet .list-template-sheet .listViewTmplContentChild {\n    border-top: 1px solid var(--sdk-chat-window-checkbox-border);\n\tmargin-bottom:10px;\n    width: 100%;\n    border-radius: 10px;\n    box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);\n    background-color: var(--sdk-chat-widow-default-white);\n    height: 56px;\t\n    cursor: pointer;\n    display: table;   \n}\n    .kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayMonth{\n      width: 40%;\n      margin: 0 auto;\n    }\n    .kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayMonth .tabs {\n        color: var(--sdk-chat-window-list-template-sub-title-color);\n        cursor: pointer;\n        font-size: 14px;       \n    }\n    .kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayMonth .tabs:last-child{\n        float: right;\n    }\n    .kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayMonth .tabs.active {\n     \n            font-size: 14px;\n            font-weight: bold;\n            color: var(--sdk-chat-widow-primary-blue-color);\n          \n    }\n    .kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayMonth .btnBG{\t\n        height: 26px;\t\n        border-radius: 6px;\t\n        display: inline-block;\t\n        padding: 5px 10px;\n        text-align: center;\t\t\n    }\t\n            \n    .kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayMonth .tabs.active .btnBG{\t\n        background-color: var(--sdk-chat-window-viewmore-btn-color);\t\n        color: var(--sdk-chat-widow-default-white);\t\n              \n    }\n    .kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .listViewRightContent img{\n        height: 36px;\n        width: 36px;\n        border-radius: 50%;\n    }\n    .kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayListValues{\t\n        width:100%;    \n        padding: 0 10px;\n    }\n    .kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayListValues .displayListValues{\n        padding: 0;\n    }\n    .kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayListValues .listViewRightContent{\n        cursor: pointer;\n    display: table-cell;\n    width: 60px;\n    vertical-align: middle;\n    padding-left: 10px;\n    }\n    .kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayListValues .listViewLeftContent{\n        width: 100%;\n        padding: 0 10px;\n        vertical-align: middle;\n        display: table-cell;\n    }\n    .kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayListValues .listViewLeftContent .listViewItemTitle{\n        font-size: 13px;\t\n    font-weight: 600;\t\n    line-height: 1.54;\t\n    letter-spacing: -0.1px;\t\n    color: var(--sdk-chat-window-list-template-title-color);\t\n    overflow: hidden;\t\n    text-overflow: ellipsis;\t\n    white-space: nowrap;\n }\n .kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayListValues .listViewLeftContent .listViewItemSubtitle{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    /* width: 102px;\n    height: 18px; */\n    font-size: 13px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: 0.27px;\n    color: var(--sdk-chat-window-list-template-sub-title-color);\n}\n \n .kore-chat-window .kore-action-sheet .list-template-sheet .listTemplateContainer .displayListValues .listViewLeftContent .listViewItemValue{\n    display: inline-block;\n     /* margin-left: 15px;  */\n    color: var(--sdk-chat-window-list-template-value-color);\n    /* width: 66px;\n    height: 22px; */\n    font-size: 14px;\n    font-weight: 900;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: 0.4px;\n    text-align: right;\n    color:  var(--sdk-chat-window-list-view-value-color);\n    overflow: hidden;\n    text-overflow: ellipsis; \n    white-space: nowrap;\n    width:33%;\n      \n }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
